module.exports = __webpack_public_path__ + "img/cloud-computing.466da53a.png";